export const moveDashboardsChartsToTopLevel = (clonedElement: HTMLElement) => {
  const dashboardsCharts = clonedElement.querySelectorAll('.dashboards-charts');
  dashboardsCharts.forEach((chartsContainer) => {
    const parent = chartsContainer.parentNode;
    if (parent) {
      while (chartsContainer.firstChild) {
        parent.insertBefore(chartsContainer.firstChild, chartsContainer);
      }
      parent.removeChild(chartsContainer);
    }
  });
};
